import React, { useEffect, useState, useContext } from "react";
import styles from "./ModalTransferRequest.module.css";
import Button from "../button/Button";
import Select from "../select/Select";
import * as publicApi from "../../../service/publicApi";
import * as laboratoryApi from "../../../service/labPersonalApi";
import ModalConfirmTransfer from "./ModalConfirmTransfer";
import { CurrentUserContext } from "../../../App";

export default function ModalTransferRequest({ onClose }) {
  const { setIsMessage } = useContext(CurrentUserContext);

  const [laboratory, setLaboratory] = useState("");
  const [optionLab, setOptionLab] = useState([]);

  const [openModal, setOpenModal] = useState(false);

  useEffect(() => {
    getLaboratoryList();
  }, []);

  const getLaboratoryList = async () => {
    let res = await publicApi.getLaboratoryList();
    if (res) {
      if (res["data"]["code"] === 200) {
        setOptionLab(
          res["data"]["laboratory_list"].map((item) => {
            return {
              key: item["laboratory_id"],
              value: item["laboratory_name"],
              address: item["current_address"],
            };
          }),
        );
      } else {
        setIsMessage({ type: "warning", data: res["data"]["message_th"] });
      }
    } else {
      alert(res["data"]["message_th"]);
    }
  };

  const transferAccount = async () => {
    let userData = JSON.parse(localStorage.getItem("user"));
    let res = await laboratoryApi.transferAccount(laboratory, userData);
    if (res) {
      if (res["data"]["code"] === 200) {
        setIsMessage({ type: "success", data: "สำเร็จ" });
        onClose();
      } else {
        setIsMessage({ type: "warning", data: res["data"]["message_th"] });
      }
    } else {
      setIsMessage({ type: "warning", data: res["data"]["message_th"] });
    }
  };

  const clickTransfer = () => {
    if (!laboratory) {
      setIsMessage({ type: "warning", data: "กรุณาเลือกชื่อห้องปฏิบัติการ" });
      return;
    }
    transferAccount();
  };

  const addressLab = [];

  const checkObjectId = () => {
    // console.log(laboratory)
    // console.log(optionLab)
    for (let i = 0; i < optionLab.length; i++) {
      if (optionLab[i]["key"] == laboratory) {
        addressLab.push(optionLab[i]["address"]);
      }
    }
  };
  checkObjectId();
  // console.log(addressLab)

  return (
    <div className={styles.overlay}>
      <div className={styles.modalController}>
        <div className={styles.closeButton}>
          <img
            onClick={() => {
              onClose();
            }}
            src={require("../../../asset/icon/close-icon.svg").default}
          ></img>
        </div>
        <div className={styles.contentModal}>
          <div className={styles.textTitle}>
            กรุณาเลือกห้องปฏิบัติการที่ต้องการย้าย
          </div>
          <hr className={styles.hrLine} />
          <div className={styles.align}>
            <Select
              disabledLabel
              placeholder="เลือกชื่อห้องปฏิบัติการ"
              value={laboratory}
              setValue={setLaboratory}
              list={optionLab}
            />
            <div
              className={styles.textSubTitle}
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 10fr",
                gridGap: "10px",
              }}
            >
              <div>ที่อยู่ : </div>
              <div>
                {laboratory ? (
                  <>
                    {addressLab[0]?.["address"]} หมู่{" "}
                    {addressLab[0]?.["village_number"]} ตำบล
                    {addressLab[0]?.["sub_district_name"]} อำเภอ
                    {addressLab[0]?.["district_name"]} จังหวัด
                    {addressLab[0]?.["province_name"]}{" "}
                    {addressLab[0]?.["post_code"]}
                  </>
                ) : (
                  " "
                )}
              </div>
            </div>
            <div className={styles.alignButton}>
              <Button style={{ width: "180px" }} onClick={clickTransfer}>
                ส่งคำขอไปยังแอดมิน
              </Button>
            </div>
          </div>
        </div>
      </div>
      {openModal ? (
        <>
          <ModalConfirmTransfer
            close={() => {
              setOpenModal(false);
            }}
          />
        </>
      ) : null}
    </div>
  );
}
